const initialValues = {
  old: '',
  new: '',
  repeat: '',
};

export default initialValues;
